import React from 'react'

import Button, { ButtonVariant } from '../../components/ui/button'
import InvoiceOverlayModal from '../../components/modals'
import { GuestPendingIntent } from '../../lib/guestInvoiceDraftStorage'

type Props = {
  open: boolean
  pendingIntent: GuestPendingIntent
  primaryAction: GuestPendingIntent
  onKeepEditing: () => void
  onViewPdf: () => void
  onSendInvoice: () => void
}

const GuestInvoiceReadyPrompt: React.FC<Props> = ({
  open,
  pendingIntent,
  primaryAction,
  onKeepEditing,
  onViewPdf,
  onSendInvoice,
}) => (
  <InvoiceOverlayModal
    open={open}
    onClose={onKeepEditing}
    title='Your invoice is ready'
    description={
      pendingIntent === 'send'
        ? 'You signed in to send this invoice. What would you like to do next?'
        : 'You signed in to preview this invoice. What would you like to do next?'
    }
  >
    <div className='d-flex flex-column flex-sm-row justify-content-end gap-2'>
      <Button type='button' variant={ButtonVariant.PLAIN} onClick={onKeepEditing}>
        Keep Editing
      </Button>
      <Button
        type='button'
        variant={primaryAction === 'viewPdf' ? ButtonVariant.PRIMARY : ButtonVariant.LIGHT}
        onClick={onViewPdf}
      >
        View PDF
      </Button>
      <Button
        type='button'
        variant={primaryAction === 'send' ? ButtonVariant.PRIMARY : ButtonVariant.LIGHT}
        onClick={onSendInvoice}
      >
        Send Invoice
      </Button>
    </div>
  </InvoiceOverlayModal>
)

export default GuestInvoiceReadyPrompt
